const layout = {
  xs: 12,
};
export default {
  ref: "products",
  title: "Products",
  id: "products",
  type: "object",
  previewUrl: {
    // local: "http://localhost:3000/shop/product/{entryId}?preview=true",
    // staging:
    //   "https://staging.waterstone.co.za/shop/product/{entryId}?preview=true",
    // production: "https://waterstone.co.za/shop/product/{entryId}?preview=true"
    preview:
      "https://staging.waterstone.co.za/shop/product/{entryId}?preview=true",
  },
  tabs: [
    "Product",
    "Price",
    "Linked Items",
    "Description",
    "Attachments",
    "Sites",
  ],
  properties: {
    brand: {
      tab: "Product",
      layout: {
        ...layout,
      },
      type: "string",
      label: "Brand & Range",
      relation: {
        ref: "brands",
        fields: ["name"],
      },
      component: "treeSelect",
    },
    classification: {
      tab: "Product",
      layout: {
        ...layout,
      },
      type: "array",
      label: "Classification",
      relation: {
        ref: "classification",
        fields: ["name"],
      },
      component: "treeSelect",
    },
    productCode: {
      tab: "Product",
      layout: {
        ...layout,
        md: 6,
      },
      type: "string",
      label: "Product Code",
      component: "text",
    },
    supplierCode: {
      tab: "Product",
      layout: {
        ...layout,
        md: 6,
      },
      type: "string",
      label: "Supplier Code",
      component: "text",
    },
    titleA: {
      tab: "Product",
      layout: {
        ...layout,
        md: 6,
      },
      type: "string",
      label: "Title A",
      component: "text",
    },
    titleB: {
      tab: "Product",
      layout: {
        ...layout,
        md: 6,
      },
      type: "string",
      label: "Title B",
      component: "text",
    },
    showPrice: {
      tab: "Price",
      layout: {
        ...layout,
        md: 2,
      },
      type: "boolean",
      label: "Show Price",
      component: "switch",
    },
    price: {
      tab: "Price",
      layout: {
        ...layout,
        md: 10,
      },
      type: "number",
      label: "Price",
      component: "number",
      step: "0.01",
      min: 0,
    },
    showSpecialPrice: {
      tab: "Price",
      layout: {
        ...layout,
        md: 2,
      },
      type: "boolean",
      label: "Show Special Price",
      component: "switch",
    },
    specialPrice: {
      tab: "Price",
      layout: {
        ...layout,
        md: 10,
      },
      type: "number",
      label: "Special Price",
      component: "number",
      step: "0.01",
      min: 0,
    },
    images: {
      tab: "Product",
      layout: {
        ...layout,
      },
      type: "array",
      label: "Images",
      component: "file",
    },
    linkedItems: {
      tab: "Linked Items",
      layout: {
        ...layout,
      },
      type: "array",
      label: "Linked Items",
      component: "repeater",
      properties: {
        product: {
          layout: {
            ...layout,
            md: 10,
          },
          type: "string",
          label: "Product",
          relation: {
            ref: "products",
            fields: ["productCode", "titleA"],
          },
          component: "search",
        },
        qty: {
          layout: {
            ...layout,
            md: 2,
          },
          type: "number",
          label: "Qty",
          component: "number",
        },
      },
    },
    material: {
      tab: "Description",
      layout: {
        ...layout,
        md: 6,
      },
      type: "string",
      label: "Material",
      component: "select",
      enum: [
        {
          label: "Ceramic",
          value: "Ceramic",
        },
        {
          label: "Stainless Steel",
          value: "Stainless Steel",
        },
        {
          label: "Brass Chrome Plated",
          value: "Brass Chrome Plated",
        },
        {
          label: "Acrylic",
          value: "Acrylic",
        },
        {
          label: "Volcanic Limestone",
          value: "Volcanic Limestone",
        },
        {
          label: "Graphite",
          value: "Graphite",
        },
        {
          label: "SilGranite",
          value: "SilGranite",
        },
        {
          label: "SilicaTec",
          value: "SilicaTec",
        },
        {
          label: "PVC",
          value: "PVC",
        },
        {
          label: "Duraplast",
          value: "Duraplast",
        },
        {
          label: "Metal",
          value: "Metal",
        },
        {
          label: "Brass",
          value: "Brass",
        },
        {
          label: "Glass",
          value: "Glass",
        },
        {
          label: "ABS Plastic",
          value: "ABS Plastic",
        },
        {
          label: "Composite Resin & Stone",
          value: "Composite Resin & Stone",
        },
        {
          label: "Wood",
          value: "Wood",
        },
        {
          label: "Fragranite",
          value: "Fragranite",
        },
        {
          label: "Ceran",
          value: "Ceran",
        },
        {
          label: "Die-Cast Zinc",
          value: "Die-Cast Zinc",
        },
      ],
    },
    finish: {
      tab: "Description",
      layout: {
        ...layout,
        md: 6,
      },
      type: "string",
      label: "Finish",
      component: "select",
      enum: [
        {
          label: "White",
          value: "White",
        },
        {
          label: "Coffee",
          value: "Coffee",
        },
        {
          label: "Rock Grey",
          value: "Rock Grey",
        },
        {
          label: "Black",
          value: "Black",
        },
        {
          label: "Brass",
          value: "Brass",
        },
        {
          label: "Chrome",
          value: "Chrome",
        },
        {
          label: "Chrome/Mirror Glass ",
          value: "Chrome/Mirror Glass ",
        },
        {
          label: "Chrome/Black Glass",
          value: "Chrome/Black Glass",
        },
        {
          label: "Polished Nickel",
          value: "Polished Nickel",
        },
        {
          label: "Satin",
          value: "Satin",
        },
        {
          label: "Alu Metallic",
          value: "Alu Metallic",
        },
        {
          label: "Anthracite",
          value: "Anthracite",
        },
        {
          label: "Champagne",
          value: "Champagne",
        },
        {
          label: "Sand",
          value: "Sand",
        },
        {
          label: "Stainless Steel",
          value: "Stainless Steel",
        },
        {
          label: "Stainless Steel Polished",
          value: "Stainless Steel Polished",
        },
        {
          label: "Stainless Steel Brushed",
          value: "Stainless Steel Brushed",
        },
        {
          label: "Stainless Steel Matt",
          value: "Stainless Steel Matt",
        },
        {
          label: "Silver",
          value: "Silver",
        },
        {
          label: "Glass",
          value: "Glass",
        },
        {
          label: "Grey",
          value: "Grey",
        },
        {
          label: "White/Chrome",
          value: "White/Chrome",
        },
        {
          label: "Stone Grey",
          value: "Stone Grey",
        },
        {
          label: "Gun Metal",
          value: "Gun Metal",
        },
        {
          label: "Wood",
          value: "Wood",
        },
        {
          label: "Manhattan Grey",
          value: "Manhattan Grey",
        },
        {
          label: "Metallic",
          value: "Metallic",
        },
        {
          label: "Mirror",
          value: "Mirror",
        },
        {
          label: "Mint",
          value: "Mint",
        },
        {
          label: "Cool Sunrise",
          value: "Cool Sunrise",
        },
        {
          label: "Warm Sunset",
          value: "Warm Sunset",
        },
        {
          label: "Hard Graphite",
          value: "Hard Graphite",
        },
        {
          label: "Brushed Gold",
          value: "Brushed Gold",
        },
        {
          label: "Brushed Gun Grey",
          value: "Brushed Gun Grey",
        },
        {
          label: "Brushed Nickel",
          value: "Brushed Nickel",
        },
        {
          label: "Brushed Cool Sunrise",
          value: "Brushed Cool Sunrise",
        },
        {
          label: "Brushed Warm Sunset",
          value: "Brushed Warm Sunset",
        },
        {
          label: "Brushed Hard Graphite",
          value: "Brushed Hard Graphite",
        },
      ],
    },

    dimensions: {
      tab: "Description",
      layout: {
        ...layout,
      },
      type: "array",
      label: "Dimension",
      id: "dimensions",
      component: "repeater",
      properties: {
        type: {
          layout: {
            ...layout,
            lg: 4,
            xl: 4,
          },
          type: "string",
          label: "Type",
          component: "select",
          enum: [
            {
              label: "Length",
              value: "Length",
            },
            {
              label: "Width",
              value: "Width",
            },
            {
              label: "Height",
              value: "Height",
            },
            {
              label: "Weight",
              value: "Weight",
            },
            {
              label: "Volume",
              value: "Volume",
            },
            {
              label: "Diameter",
              value: "Diameter",
            },
            {
              label: "Bowl Depth",
              value: "Bowl Depth",
            },
            {
              label: "Depth",
              value: "Depth",
            },
            {
              label: "Sheets per m²",
              value: "Sheets per m²",
            },
            {
              label: "Seats",
              value: "Seats",
            },
          ],
        },
        value: {
          layout: {
            ...layout,
            lg: 4,
            xl: 4,
          },
          type: "text",
          label: "Value",
          component: "text",
        },
        unit: {
          layout: {
            ...layout,
            lg: 4,
            xl: 4,
          },
          type: "string",
          label: "Unit",
          component: "select",
          enum: [
            {
              label: "mm",
              value: "mm",
            },
            {
              label: "kg",
              value: "kg",
            },
            {
              label: "m",
              value: "m",
            },
            {
              label: "ltr",
              value: "ltr",
            },
            {
              label: "m²",
              value: "m²",
            },
            {
              label: "Seater",
              value: "Seater",
            },
          ],
        },
      },
    },
    colourOptions: {
      tab: "Description",
      layout: {
        ...layout,
      },
      type: "array",
      label: "Colour Options",
      component: "repeater",
      properties: {
        colour: {
          layout: {
            ...layout,
          },
          type: "text",
          label: "Colour",
          component: "text",
        },
        image: {
          layout: {
            ...layout,
          },
          type: "array",
          label: "Image",
          component: "file",
        },
      },
    },
    attachments: {
      tab: "Attachments",
      layout: {
        ...layout,
      },
      type: "array",
      label: "Attachments",
      component: "repeater",
      properties: {
        type: {
          layout: {
            ...layout,
          },
          type: "string",
          label: "Type",
          component: "select",
          enum: [
            {
              label: "CAD DWG 2D A",
              value: "CAD DWG 2D A",
            },
            {
              label: "CAD DWG 2D B",
              value: "CAD DWG 2D B",
            },
            {
              label: "CAD DWG 2D C",
              value: "CAD DWG 2D C",
            },
            {
              label: "CAD DWG 3D A",
              value: "CAD DWG 3D A",
            },
            {
              label: "CAD DWG 3D B",
              value: "CAD DWG 3D B",
            },
            {
              label: "CAD DWG 3D C",
              value: "CAD DWG 3D C",
            },
            {
              label: "CAD DXF 2D A",
              value: "CAD DXF 2D A",
            },
            {
              label: "CAD DXF 2D B",
              value: "CAD DXF 2D B",
            },
            {
              label: "CAD DXF 2D C",
              value: "CAD DXF 2D C",
            },
            {
              label: "CAD DXF 3D A",
              value: "CAD DXF 3D A",
            },
            {
              label: "CAD DXF 3D B",
              value: "CAD DXF 3D B",
            },
            {
              label: "CAD DXF 3D C",
              value: "CAD DXF 3D C",
            },
            {
              label: "REVIT A",
              value: "REVIT A",
            },
            {
              label: "REVIT B",
              value: "REVIT B",
            },
            {
              label: "REVIT C",
              value: "REVIT C",
            },
            {
              label: "Installation Manual",
              value: "Installation Manual",
            },
            {
              label: "Technical Data Sheet",
              value: "Technical Data Sheet",
            },
          ],
        },
        file: {
          layout: {
            ...layout,
          },
          type: "array",
          label: "File",
          component: "file",
        },
      },
    },
    info: {
      tab: "Product",
      layout: {
        ...layout,
      },
      type: "string",
      label: "Info",
      component: "wysiwyg",
    },
    site1: {
      tab: "Sites",
      layout: {
        ...layout,
      },
      type: "boolean",
      label: "Site 1",
      component: "switch",
    },
    site2: {
      tab: "Sites",
      layout: {
        ...layout,
      },
      type: "boolean",
      label: "Site 2",
      component: "switch",
    },
    site3: {
      tab: "Sites",
      layout: {
        ...layout,
      },
      type: "boolean",
      label: "Site 3",
      component: "switch",
    },
    site4: {
      tab: "Sites",
      layout: {
        ...layout,
      },
      type: "boolean",
      label: "Site 4",
      component: "switch",
    },
    site5: {
      tab: "Sites",
      layout: {
        ...layout,
      },
      type: "boolean",
      label: "Site 5",
      component: "switch",
    },
  },
};

// const dimensions = new Array(100).fill({
//   ...{
//     type: 'Length',
//     value: 10,
//     unit: 'mm'
//   }
// });

const dimensions = [
  {
    type: "Length",
    value: 10,
    unit: "mm",
  },
  {
    type: "Length",
    value: 10,
    unit: "mm",
  },
];

export const mockData = {
  titleA: "Woot",
  site1: true,
  dimensions,
};
